module.exports = __webpack_public_path__ + "static/petr-61d74344376746f334d014629fd9baa8.jpg";